import GiftCardRedeemComponent from 'src/components/GiftCardRedeem/gift-card-redeem';

const RedeemGiftCardPage: React.FC = () => {
  return <GiftCardRedeemComponent />;
};

//@todo: remove this function once this is safely in prod as it's just a feature flag
export const getServerSideProps = async () => {
  if (!process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY) {
    return {
      notFound: true,
    };
  }
  return {
    props: {},
  };
};

export default RedeemGiftCardPage;
